import { calculatePaginationOffset, compareValues, convertSortToQueryString, } from "@sscs/utils";
import { REPORTS_ENDPOINT } from "../../constants";
import { compareIssueOverrides } from "../../utils";
import { baseApi } from "./base.api.required.stub";
const convertFilter = (filter) => {
    return Object.entries(filter).map(([key, filterItem]) => {
        let values = filterItem.values;
        if (key === "level") {
            values = filterItem.values.map((value) => parseInt(value));
        }
        return {
            filter_by: key,
            operation: filterItem.operation,
            values: values,
        };
    });
};
export const issuesApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getIssues: build.query({
            // matchFulfilled only fires on real fetches, not cache hits. Without keepUnusedDataFor=0,
            // extraReducer matchers (issuesApi.endpoints.getIssues.matchFulfilled) silently
            // skip on re-navigation because RTK Query serves cached data instead of fetching.
            keepUnusedDataFor: 0,
            query: (data) => {
                const { diffId, filter, sort, pagination } = data;
                const body = {
                    diff_id: diffId,
                    limit: pagination.itemsPerPage,
                    offset: calculatePaginationOffset(pagination),
                    sort_by: convertSortToQueryString(sort),
                    filters: convertFilter(filter),
                };
                return {
                    url: `${REPORTS_ENDPOINT}/${data.reportId}/issues`,
                    body: body,
                    method: "POST",
                };
            },
            transformResponse: (data) => {
                return {
                    issues: data.issues.map((issue) => ({
                        ...issue,
                        overrides: issue.overrides.toSorted(compareIssueOverrides),
                    })),
                    match_count: data.match_count,
                    risk_count: data.risk_count,
                };
            },
        }),
        getComponentList: build.query({
            query: (data) => {
                const { diffId, filter, sort, pagination, enabled, status } = data;
                const body = {
                    diff_id: diffId,
                    limit: pagination.itemsPerPage,
                    offset: calculatePaginationOffset(pagination),
                    sort_by: convertSortToQueryString(sort),
                    filters: convertFilter(filter),
                    enabled: enabled,
                    status: status,
                };
                return {
                    url: `${REPORTS_ENDPOINT}/${data.ui_id}/issues/${data.ui_item_id}/components`,
                    body: body,
                    method: "POST",
                };
            },
        }),
        getPolicyDescriptionList: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/issues/policies`,
            }),
        }),
        getPathList: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/issues/paths`,
            }),
        }),
        getPublisherList: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/issues/publishers`,
            }),
            transformResponse: (data) => {
                return data.sort((first, second) => compareValues(first.value, second.value, false));
            },
        }),
        getTagList: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/issues/tags`,
            }),
        }),
        getComponentAgesList: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/issues/component-ages`,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetIssuesQuery, useGetComponentListQuery, useLazyGetPathListQuery, useLazyGetPolicyDescriptionListQuery, useLazyGetPublisherListQuery, useLazyGetTagListQuery, useGetPathListQuery, useLazyGetComponentAgesListQuery, } = issuesApi;
//# sourceMappingURL=issues.api.js.map